import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "./Achievers.css";
import { SLIDER_AUTOPLAY_DELAY_MS } from "../constants/sliderTiming";
import useScrollAnimation from "../constants/useScrollAnimation";

const achieversData = [
  {
    img: "/images/achievers/Avishikta_Dey.jpg",
    text: "Avishikta Dey of Techno India Group Public School Siliguri has been awarded the Miss Teen India",
  },
  {
    img: "/images/achievers/Ayushmita_Chakraborty.jpg",
    text: "Ayushmita Chakraborty of class V Techno Global School, Malda, was honored by 2nd position in all India dance competition at Bhilai and achieved 1st position in Group.",
  },
  {
    img: "/images/achievers/Baiduriya_Biswas.jpg",
    text: "Baiduriya Biswas of TIGPS, Hooghly achieved remarkable success in Rifle Shooting, showcasing",
  },
  {
    img: "/images/achievers/Ireen_Halder.jpg",
    text: "Ireen Halder of TIGPS Siliguri took part in 3rd Himalayan Swimming Meet at Gangtok and stood 1st",
  },
  {
    img: "/images/achievers/National_Table_Tennis_Championship_2023.jpg",
    text: "TIGPS, Siliguri, West Bengal had participated in the CBSE National Table Tennis Championship 2023",
  },
];

const Achievers = () => {
  const [activeIndex, setActiveIndex] = useState(1);
  const [hoverIndex, setHoverIndex] = useState(null);
  const [headerRef, isHeaderVisible] = useScrollAnimation(0.2);
  const [contentRef, isContentVisible] = useScrollAnimation(0.2);

  return (
    <section>
      <div className="achievers">
        <div className="container-custom">
          <div ref={headerRef} className={`section-header ${isHeaderVisible ? "animate-in" : ""}`}>
            <div className="section-title-body">
              <div>
                <h3 className="section-title-hm">Achievers</h3>
              </div>
              <div>
                <a href="#" class="btn-com school-view"> Learn more</a>
              </div>
            </div>
            <p className="section-desc body-txt">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of type
              and scrambled it to make a type specimen book. It has survived not
              only five centuries, but also the leap into electronic
            </p>
          </div>
          <div ref={contentRef} className={`schools-right ${isContentVisible ? "animate-in" : ""}`}>
            <Swiper
            modules={[Navigation, Autoplay]}
            navigation={false}
            autoplay={{ delay: SLIDER_AUTOPLAY_DELAY_MS }}
            loop={true}
            centeredSlides={true}
            slidesPerView={3}
            spaceBetween={30} // THIS ADDS SPACE BETWEEN CARDS
            onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
            breakpoints={{
              0: { slidesPerView: 1, spaceBetween: 20 },
              768: { slidesPerView: 2, spaceBetween: 25 },
              1024: { slidesPerView: 3, spaceBetween: 30 },
            }}
          >
            {achieversData.map((item, index) => {
              const isActive = hoverIndex === index || activeIndex === index;

              return (
                <SwiperSlide
                  key={index}
                  onMouseEnter={() => setHoverIndex(index)}
                  onMouseLeave={() => setHoverIndex(null)}
                  className="slide-wrapper"
                >
                  <div>
                    <div
                      className={`achiever-card ${isActive ? "active-card" : ""}`}
                    >
                      <img src={item.img} className="achiever-img" alt="" />
                    </div>
                  </div>

                  {/* Show text when slide is hovered OR center slide */}
                  <div className={`achiever-info ${isActive ? "show-info" : ""}`}>
                    {item.text}
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Achievers;
